import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_CUSTOMER_DETAIL_DATA_INIT } from './constants';
import {
  fetchCustomerDetailSuccess,
  fetchCustomerDetailFailure,
} from './actions';
import { fetchCustomerDetailData } from './service'; /// come back

function* fetchCustomerDetailDataSaga({ payload }) {
  try {
    const response = yield call(fetchCustomerDetailData, payload); //come back
    yield put(fetchCustomerDetailSuccess(response));
  } catch (error) {
    yield put(fetchCustomerDetailFailure(error));
  }
}

function* watchFetchCustomerDetailData() {
  yield takeLatest(
    FETCH_CUSTOMER_DETAIL_DATA_INIT,
    fetchCustomerDetailDataSaga,
  );
}

export default watchFetchCustomerDetailData;
